'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _step2Functions = require('../../helpers/step2Functions');

var customValues = function customValues(formValues) {};

exports.default = function (formValues) {
  return (0, _step2Functions.transformApplicants)(formValues, customValues);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/oop/applicant.js
// module id = 419
// module chunks = 0